import ih from 'immutability-helper';

import { ENTITY_SCOPE_TYPES } from '../../../types';

/* eslint-disable import/prefer-default-export */
export const createReduxFormInitialValues = entity =>
  ih(entity, {
    public: { $set: entity.scope === ENTITY_SCOPE_TYPES.PUBLIC },
    $unset: ['scope'],
  });
